function replaceArrayTokens(array, keyValuePairs) {
  let string = array.join('|');
  string = replaceStringTokens(string, keyValuePairs);
  return string.split('|');
}

function replaceStringTokens(string, keyValuePairs) {
  Object.keys(keyValuePairs).forEach(key => {
    string = string.replaceAll(`{${key}}`, keyValuePairs[key]);
  });
  return string;
}

function install(Vue) {
  Vue.prototype.$getString = function (key) {
    return this.$store.getters.string(key);
  };
  Vue.prototype.$getTemplatedString = function (key, keyValuePairs) {
    let string = this.$store.getters.string(key);

    if (!string) return null;

    return Array.isArray(string)
      ? replaceArrayTokens(string, keyValuePairs)
      : replaceStringTokens(string, keyValuePairs);
  };
}

export default { install };